/**
 * Email / password login form for local auth mode.
 */

import React, { useState, FormEvent } from 'react';
import { localLogin } from '../../contexts/auth/LocalAuthContext';

const LocalLoginForm: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setError(null);
    setIsSubmitting(true);
    try {
      await localLogin(email, password);
    } catch (err: any) {
      setError(err.message || 'Login failed');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-sm space-y-5">
      <h2 className="text-2xl font-semibold text-center text-ui-text-primary">
        Sign in
      </h2>

      {error && (
        <div className="rounded-md bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 p-3 text-sm text-red-700 dark:text-red-400">
          {error}
        </div>
      )}

      <div className="space-y-1">
        <label htmlFor="login-email" className="block text-sm font-medium text-ui-text-secondary">
          Email
        </label>
        <input
          id="login-email"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full rounded-md border border-ui-border-primary bg-ui-background-secondary px-3 py-2 text-sm text-ui-text-primary placeholder-ui-text-tertiary focus:outline-none focus:ring-2 focus:ring-lime-400"
          placeholder="you@company.com"
        />
      </div>

      <div className="space-y-1">
        <label htmlFor="login-password" className="block text-sm font-medium text-ui-text-secondary">
          Password
        </label>
        <input
          id="login-password"
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full rounded-md border border-ui-border-primary bg-ui-background-secondary px-3 py-2 text-sm text-ui-text-primary placeholder-ui-text-tertiary focus:outline-none focus:ring-2 focus:ring-lime-400"
          placeholder="••••••••"
        />
      </div>

      <button
        type="submit"
        disabled={isSubmitting}
        className="w-full rounded-md bg-lime-500 hover:bg-lime-600 disabled:opacity-50 text-white font-medium py-2 text-sm transition-colors"
      >
        {isSubmitting ? 'Signing in…' : 'Sign in'}
      </button>

      <p className="text-center text-sm text-ui-text-tertiary">
        Don&apos;t have an account?{' '}
        <a href="/sign-up" className="text-lime-500 hover:underline">
          Sign up
        </a>
      </p>

      <p className="text-center text-xs text-ui-text-tertiary">
        <a href="/forgot-password" className="hover:underline">
          Forgot password?
        </a>
      </p>
    </form>
  );
};

export default LocalLoginForm;
